import Menu from "../../components/Menu";

export default function Home() {
    return (
        <>
            <Menu />
        </>
    )
}